import React, { useEffect, useState } from "react";
import "../ForderPage/folder.css";
import dossierClient from "../../image/dossierClient.png";
import Modal from "components/Modal";
import arrow from "../../image/arrow-left.png";
import { FormProvider, useForm } from "react-hook-form";
import { getUser } from "redux/features/userSliceWithTokenValidation";
import { useSelector } from "react-redux";
import HeaderButton from "utils/headerButton";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import SkeletonComponent from "utils/skeleton/skeleton";
import { toastApiErrors } from "utils/toastApiError";
import { useGetDossierActivatedQuery } from "actions/dossiers/queries";
import {
  useDeleteDossierMutation,
  useUpdateDossierMutation,
} from "actions/dossiers/mutations";
import GridList from "react-flexible-list";
import { usePermissions } from "hooks/usePermissions";
import { GoInbox } from "react-icons/go";
import ButtonWhite from "components/buttons/ButtonWhite";
import ConfirmModal from "utils/ConfirmationModal";
import EditDossierModal from "components/EditDossierModal";

const ForderListPage = () => {
  const [updateDossier] = useUpdateDossierMutation();
  const [deleteDossier] = useDeleteDossierMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDossierData, setSelectedDossierData] = useState(null);
  const navigate = useNavigate();
  const permissions = usePermissions();

  const userStatus = useSelector(getUser);
  const comptableId = userStatus?.id;
  const { data, isLoading, refetch } = useGetDossierActivatedQuery({
    comptableId,
    activated: "False",
  });
  const [doubleClickCount, setDoubleClickCount] = useState({});
  const [doubleClickTimer, setDoubleClickTimer] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  // Utilisez la fonction `filter` pour filtrer les dossiers en fonction du terme de recherche
  const filteredDossiers = data?.data?.filter(
    (dossier) =>
      dossier?.nom_entreprise
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) && !dossier?.archived
  );

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const [selectedDossier, setSelectedDossier] = useState(null);
  const handleDossierClick = (dossierId) => {
    setSelectedDossier((prevSelectedDossier) =>
      prevSelectedDossier === dossierId ? null : dossierId
    );
    if (doubleClickCount[dossierId]) {
      navigate(`/client/${dossierId}`);

      // Réinitialiser le compteur de clics pour le dossier
      setDoubleClickCount((prevCounts) => ({
        ...prevCounts,
        [dossierId]: 0,
      }));
    } else {
      // Dossier cliqué une fois, mettre à jour le compteur
      setDoubleClickCount((prevCounts) => ({
        ...prevCounts,
        [dossierId]: 1,
      }));

      // Configurer un timer pour réinitialiser le compteur après un certain délai
      const timer = setTimeout(() => {
        setDoubleClickCount((prevCounts) => ({
          ...prevCounts,
          [dossierId]: 0,
        }));
      }, 300); // Ajustez le délai selon vos besoins

      // Stocker le timer dans l'état pour pouvoir le nettoyer si nécessaire
      setDoubleClickTimer((prevTimers) => ({
        ...prevTimers,
        [dossierId]: timer,
      }));
    }
  };

  // Nettoyer les timers lors du démontage du composant
  useEffect(() => {
    return () => {
      if (doubleClickTimer) {
        Object.values(doubleClickTimer).forEach(clearTimeout);
      }
    };
  }, [doubleClickTimer]);

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = viewportWidth <= 768;
  const dossierCardWidth = isMobile
    ? Math.max(92, Math.floor((viewportWidth - 70) / 2))
    : 150;

  const handleEyesClick = () => {
    if (selectedDossier !== null) {
      // Ouvrir le dossier dans une nouvelle approche : modal de modification
      const dossier = filteredDossiers?.find((d) => d.id === selectedDossier);
      if (dossier) {
        setSelectedDossierData(dossier);
        setIsEditModalOpen(true);
      }
    }
  };

  //  const refetchData = async () => {
  //   try {
  //     // Utilisez l'async/await pour attendre la résolution de la requête de refetch
  //     const refetchResult = await refetch();

  //     // Assurez-vous que la requête de refetch s'est terminée avec succès avant de traiter les données
  //     if (refetchResult && refetchResult.status === 'fulfilled') {
  //       console.log('Refetch des données réussi');
  //     } else {
  //       console.error('Échec du refetch des données');
  //     }
  //   } catch (error) {
  //     console.error('Erreur lors du refetch des données', error);
  //   }
  // };

  // DEACTIVATION
  const handleActiveClick = async () => {
    if (selectedDossier !== null) {
      const dossierId = selectedDossier;
      try {
        await updateDossier({
          id: dossierId,
          body: { activated: true },
          token: userStatus?.access,
        }).unwrap();
        toast.success("Entreprise désactivée avec succès");
        setSelectedDossier(null);
        await refetch();
      } catch (error) {
        console.error("Échec de désactivation de l'entreprise", error);
        toastApiErrors(error);
      }
    } else {
      console.error("ID de l'entreprise n'est pas valide :", selectedDossier);
    }
  };

  // ARCHIVAGE
  const handleArchiveClick = async () => {
    if (selectedDossier !== null) {
      const dossierId = selectedDossier;
      try {
        await updateDossier({
          id: dossierId,
          body: { archived: true },
          token: userStatus?.access,
        }).unwrap();
        toast.success("Entreprise archivée avec succès");
        setSelectedDossier(null);
        await refetch();
      } catch (error) {
        console.error("Échec de l'archivage de l'entreprise", error);
        toastApiErrors(error);
      }
    } else {
      console.error("ID de l'entreprise n'est pas valide :", selectedDossier);
    }
  };

  // SUPPRESSION
  const handleDeleteClick = async () => {
    if (selectedDossier !== null) {
      setIsDeleteModalOpen(true);
    }
  };

  const confirmDelete = async () => {
    const dossierId = selectedDossier;
    try {
      await deleteDossier({
        id: dossierId,
        token: userStatus?.access,
      }).unwrap();
      toast.success("Entreprise supprimée avec succès");
      setSelectedDossier(null);
      setIsDeleteModalOpen(false);
      await refetch();
    } catch (error) {
      console.error("Échec de la suppression de l'entreprise", error);
      toastApiErrors(error);
    }
  };

  const handleDossierCreated = async () => {
    await refetch();
    setIsModalOpen(false);
  };

  const methods = useForm();
  const renderDossierCard = (dossier) => (
    <div
      className="d-flex flex-column align-items-center carte"
      key={dossier?.id}
      onClick={() => handleDossierClick(dossier?.id)}
      style={{
        ...monDossierParent2,
        width: "100%",
        backgroundColor:
          selectedDossier === dossier.id ? "#CCE8FF" : "transparent",
        transform:
          selectedDossier === dossier.id ? "scale(1.05)" : "none",
        transition: "transform 0.2s ease, background-color 0.2s ease",
      }}>
      <img
        src={dossierClient}
        alt="Entreprise"
        style={{
          ...monDossier,
          width: isMobile ? "72px" : monDossier.width,
          height: isMobile ? "56px" : monDossier.height,
        }}
      />
      <p style={nomDossier}>{dossier?.nom_entreprise}</p>
    </div>
  );

  return (
    <div
      className="global"
      style={{
        backgroundColor: "white",
        height: "85vh",
        borderRadius: "20px",
        padding: "15px",
        overflow: "auto",
      }}>
      <ToastContainer />
      <div
        className="header"
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          gap: "8px",
          // padding: "13px",
        }}>
        <div
          style={{
            padding: isMobile ? "15px 15px 0 15px" : "15px",
            order: isMobile ? 0 : 2,
          }}
        >
          <ButtonWhite text={"+ Créer une entreprise"} onClick={openModal} />
        </div>
        <div
          className="header-title"
          style={{
            padding: isMobile ? "0 15px 15px 15px" : "15px",
            display: "flex",
            order: isMobile ? 0 : 1,
          }}
        >
          <h4 className="titre-dossier">Entreprises</h4>
          <span className="nbrDossier">{filteredDossiers?.length}</span>
        </div>
      </div>

      <FormProvider {...methods}>
        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          onDossierCreated={handleDossierCreated}>
          <h2 style={{ color: " #009688", fontSize: "20px", fontWeight: 700 }}>
            <span>
              {" "}
              <img src={arrow} />
            </span>{" "}
            &nbsp;CREER UNE NOUVELLE ENTREPRISE 
          </h2>
        </Modal>
      </FormProvider>

      {permissions.ACCESS_MODIFICATION && (
        <div className="mt-4">
          <HeaderButton
            isButtonsEnabled={selectedDossier !== null}
            onEyesClick={handleEyesClick}
            onClickArchive={handleArchiveClick}
            onSearchChange={handleSearchChange}
            onActivedClick={handleActiveClick}
            onClickDelete={handleDeleteClick}
            placeholder="Rechercher une entreprise..."
          />
        </div>
      )}
      <div className="mt-3">
        {isMobile ? (
          isLoading ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: 8,
              }}>
              {[1, 2, 3, 4].map((idx) => (
                <div key={`skeleton-${idx}`} style={{ width: "100%" }}>
                  <SkeletonComponent />
                </div>
              ))}
            </div>
          ) : filteredDossiers?.length ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: 8,
              }}>
              {filteredDossiers.map((dossier) => renderDossierCard(dossier))}
            </div>
          ) : (
            <div className="text-center d-flex flex-column align-items-center gap-2 mt-5 text-secondary opacity-75">
              <GoInbox className="fs-1" />
              <h6 style={{ fontFamily: "Montserrat" }}>Aucune entreprise</h6>
            </div>
          )
        ) : isLoading ? (
          <GridList
            cardWidth={200}
            resourceData={[1, 2, 3, 4, 5]}
            resourceItem={() => <SkeletonComponent />}
          />
        ) : (
          <GridList
            cardWidth={dossierCardWidth}
            emptyComponent={() => (
              <div className="text-center d-flex flex-column align-items-center gap-2 mt-5 text-secondary opacity-75">
                <GoInbox className="fs-1" />
                <h6 style={{ fontFamily: "Montserrat" }}>Aucune entreprise</h6>
              </div>
            )}
            resourceData={filteredDossiers}
            resourceItem={(dossier) => renderDossierCard(dossier)}
          />
        )}
      </div>

      <EditDossierModal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedDossierData(null);
        }}
        onUpdated={async () => {
          await refetch();
        }}
        dossier={selectedDossierData}
      />

      <ConfirmModal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
        title="Supprimer l'entreprise"
        message="Êtes-vous sûr de vouloir supprimer cette entreprise ? Cette action est irréversible."
      />
    </div>
  );
};
// const monDossierParent1 = {
//   display: 'flex',
//   flexWrap: 'wrap',
//   padding: "25px",
//   marginTop: "15px"
// }
const monDossierParent2 = {
  cursor: "pointer",
  border: "none",
  background: "none",
  padding: 10,
};
const monDossier = {
  width: "90px",
  height: "70px",
};
const nomDossier = {
  fontWeight: "600",
  fontFamily: "Montserrat",
  fontSize: "11px",
  textAlign: "center",
  marginTop: "10px",
  color: "#000000",
};

export default ForderListPage;
